export const pt = {
    translations: {
        values: {
            one: "um",
            two: "dois",
            three: "tres",
            four: "quatro",
            five: "cinco",
            six: "seis",
            seven: "sete",
            eight: "oito",
            nine: "nove",
            redFive: "cinco vermelho",
            east: "vento leste",
            south: "vento sul",
            west: "vento oeste",
            north: "vento norte",
            white: "dragao branco",
            green: "dragao verde",
            red: "dragao vermelho",
            hidden: "peca oculta",
        },
        suits: {
            characters: "caracteres",
            circles: "circulos",
            bamboo: "bambu"
        },
        shuupai: "{{value}} de {{suit}}",
        winds: {
            east: "Leste",
            south: "Sul",
            west: "Oeste",
            north: "Norte"
        },
        roundName: "{{wind}} {{number}}-{{repeats}}",
        trainer: {
            disclaimer: "Aviso: Este treinador treinara sua habilidade de maximizar a eficiencia de sua mao no turno atual. Ele nao lhe ajudara a maximizar a eficiencia em turnos futuros, ou a aprender quando e apropriado ignorar a eficiencia, ou como construir valor. Jogar como este treinador sugere em toda mao nao e a melhor maneira de jogar mahjong, mas existem maos em que voce quer jogar dessa maneira. Jogadores de nivel alto nem sempre jogam assim, mas todos os jogadores de nivel alto SABEM jogar assim. Certifique-se de suplementar este treinamento com leitura adicional para aprender quando esta pode nao ser a melhor linha de jogo, e cheque as configuracoes para um treinamento mais objetivo.",
            instructions: "Clique na peca que voce deseja descartar.",
            start: "Comecou uma nova mao: {{hand}}",
            complete: " Sua mao agora esta pronta. Parabens! Sua eficiencia foi {{achieved}}/{{total}}, ou {{percent}}%.",
            newHandButtonLabel: "Nova Mao",
            loadButtonLabel: "Carregar Mao",
            roundWind: "Vento da Rodada:",
            seatWind: "Vento do Assento:",
            doraIndicator: "Indicador de Dora:",
            copyHand: "Copiar mao",
            copied: "Copiada!",
            error: {
                load: "Erro: Nao foi possivel entender a mao fornecida",
                wallEmpty: "Erro: Nao ha pecas suficientes para fazer uma mao.",
                wallEmptyShuffle: "Nao ha pecas suficientes na muralha para fazer uma nova mao. Embaralhando."
            },
            playerNames: {
                you: "Voce",
                right: "Shimocha",
                across: "Toimen",
                left: "Kamicha"
            }
        },
        history: {
            label: "Historico da Mao",
            tenhouLinkText: "[Pecas Aceitas]",
            concise: {
                discard: "Descarte: {{tile}}",
                acceptance: " ({{count}} peca).",
                acceptance_plural: " ({{count}} pecas).",
                loweredShanten: " (recuou em shanten).",
                optimal: " Ideal:",
                optimalSpoiler: " {{tile}}",
                best: " Essa foi a melhor escolha!",
                exceptionalNoten: " Todas as suas pecas vitoriosas estao em sua mao, entao voce ainda nao esta em tenpai.",
                furiten: " Furiten.",
                furitenWarning: " Tome cuidado com furiten futuro.",
                exhausted: " Nao ha mais pecas na muralha. Mais sorte na proxima vez! ",
                draw: " Compra: {{tile}}. "
            },
            verbose: {
                discard: "Voce escolheu descartar o {{tile}}, que",
                acceptance: " resulta em {{count}} peca que pode melhorar a mao.",
                acceptance_plural: " resulta em {{count}} pecas que podem melhorar a mao.",
                loweredShanten: " aumenta seu shanten - voce agora esta mais distante da mao pronta.",
                optimal: " A peca mais eficiente de se descartar",
                optimalSpoiler: ", o {{tile}}, ",
                best: " Essa foi a melhor escolha!",
                exceptionalNoten: " Sua mao esta pronta, mas todas as suas pecas vitoriosas estao em sua mao. Isto nao conta como pronto em quase todos os conjuntos de regras, entao voce precisara mudar sua mao.",
                furiten: " Voce esta em furiten. Voce nao pode vencer esta mao por ron, porque voce tem uma peca vitoriosa em seus descartes.",
                furitenWarning: " Tome cuidado com furiten futuro. Algumas das pecas que melhoram sua mao estao em seus descartes.",
                exhausted: " Nao ha mais pecas na muralha. Mais sorte na proxima vez! ",
                draw: " Voce comprou o {{tile}}. "
            }
        },
        discards: {
            label: "Pilha de Descarte",
            discardCount: "Voce descartou {{count}} peca.",
            discardCount_plural: "Voce descartou {{count}} pecas.",
            tilesLeft: "Ha {{count}} peca restante na muralha.",
            tilesLeft_plural: "Ha {{count}} pecas restantes na muralha."
        },
        settings: {
            buttonLabel: "Configuracoes",
            tilesAllowed: "Pecas Permididas:",
            characters: "Caracteres",
            circles: "Circulos",
            bamboo: "Bambu",
            honors: "Honras",
            sanma: "Regras de tres jogadores",
            redFives: "Numero de Cincos Vermelhos:",
            verbose: "Nomes de pecas por extenso (\"um de bambu\" vs \"1s\")",
            showIndexes: "Mostrar indice das pecas",
            concise: "Historico conciso",
            spoilers: "Mostrar qual era a melhor opcao",
            shuffle: "Embaralhar pecas descartadas de volta na muralha apos iniciar uma nova mao",
            simulate: "Simular outros jogadores descartando pecas",
            exceptions: "Considerar maos de excecao (Kokushi Musou/Treze orfaos e Chiitoitsu/Sete Pares)",
            minShanten: "Shanten minimo da mao inicial:",
            minShantenLimit: "(ate o numero de naipes permitidos)",
            sort: "Organizar mao",
            blind: "Ocultar pecas da mao",
            useTimer: "Habilitar cronômetro",
            time: "Tempo para cada decisão:",
            extraTime: "Tempo extra para cada mao:",
            seconds: "segundos"
        },
        stats: {
            buttonLabel: "Estatisticas",
            info: "Estas estatisticas sao atualizadas cada vez que voce torna uma mao pronta.",
            ready: "Maos Prontas: {{count}} mao",
            ready_plural: "Maos Prontas: {{count}} maos",
            discards: "Pecas Descartadas: {{count}} peca",
            discards_plural: "Pecas Descartadas: {{count}} pecas",
            average: "Media de Descartes ate Mao Pronta: {{average}} descartes",
            optimal: "Descartes Ideais: {{count}} descarte",
            optimal_plural: "Descartes Ideais: {{count}} descartes",
            optimalRate: "Taxa de Descartes Ideais: {{percent}}% ({{achieved}}/{{total}})",
            efficiency: "Eficiencia adquirida: {{count}} peca",
            efficiency_plural: "Eficiencia adquirida: {{count}} pelas",
            possible: "Eficiencia Potencial Adquirivel: {{count}} peca",
            possible_plural: "Eficiencia Potencial Adquirivel: {{count}} pecas",
            overall: "Eficiencia Geral: {{percent}}% ({{achieved}}/{{total}})",
            reset: "Resetar Estatisticas",
            confirmation: "Tem certeza que quer resetar todas as estatisticas para zero? Voce nao pode desfazer esta acao.",
            yes: "Sim, resetar!",
            no: "Nao, nao resetar!"
        },
        credits: {
            label: "Creditos",
            tilesPreLink: "Imagens de pecas combinadas de ",
            tilesLinkText: "riichi-mahjong-tiles por FluffyStuff no Github",
            tilesPostLink: ", licenciado sob a",
            ccLinkText: "Creative Commons Attribution 4.0 International License.",
            shantenPreLink: "Algoritmo de calculo de shanten adaptado ",
            shantenLinkText: "desta colecao de programas em C.",
            shantenPostLink: "",
        },
        menu: {
            trainer: "Treinador",
            analyzer: "Analisador",
            allLast: "Treinador de All Last",
            explorer: "Explorador",
            utils: "Misc.",
            language: "Idioma",
            defense: "Abandonando a Mao"
        },
        allLast: {
            placements: {
                first: "primeiro",
                second: "segundo",
                third: "terceiro",
                fourth: "quarto"
            },
            title: "Treinador de All Last",
            maxFu: "Fu Maximo",
            showDifferences: "Mostrar diferencas na pontuacao",
            loadInstructions: "Entre placares separados por virgula para Leste, Sul, Oeste e Norte, nessa ordem, para carregar uma situacao.",
            loadLabel: "Carregar Situacao",
            newLabel: "Nova Situacao Aleatoria",
            info: "e atualmente All Last, a ultima mao da partida. Voce esta em quarto. Os placares sao os seguintes:",
            escapeHeader: "Escapando do Quarto Lugar",
            riichiHeader: "Declaracoes de Riichi",
            higherHeader: "Lugares mais altos",
            question: "Qual e a menor pontuacao com a qual voce pode {{action}} para ficar em {{placement}}?",
            riichiQuestion: "Se {{player}} declarar riichi, qual e a menor pontuacao com a qual voce pode declarar {{action}} para ficar em {{placement}}?",
            ron: "ron no descarte de {{target}} ",
            tsumo: "tsumo",
            han: "Han",
            fu: "Fu",
            submit: "Enviar",
            wrong: "Errado! Essa pontuacao nao lhe coloca em {{placement}}! Destaque com o mouse para a resposta: ",
            tooMuch: "Essa pontuacao lhe coloca em {{placement}}, mas nao e a menor possivel. Destaque com o mouse para a resposta: ",
            correct: "Correto! Essa e a menor pontuacao que lhe coloca em {{placement}}!",
            score: "{{han}} han {{fu}} fu",
            results: "Resultados:",
            you: "VOCe",
            error: {
                few: "Erro: Nao foram fornecidos placares suficientes.",
                NaN: "Erro: Nao foi possivel compreender o placar de {{seat}}."
            }
        },
        analyzer: {
            instructions1: "Instrucoes:",
            instructions2: "Cole a URL de seu replay na caixa de texto.",
            instructions3: 'Depois, clique com o botao direito no link que aparecer e escolha "Salvar Como" ou "Salvar Link Como".',
            instructions4: 'Finalmente, clique em "Browse..." e carregue o arquivo que voce salvou.',
            instructions5: "Alternativamente, se voce possuir um arquivo mjlog em seu computador, voce pode renomea-lo para terminar em .zip.",
            instructions6: "Depois, carregue o arquivo contido nesse zip.",
            instructions7: "Voce tambem pode simplesmente carregar arquivos de replay XML diretamente se voce tiver um programa que os busca para voce.",
            instructions8: "O aviso do treinador de eficiencia tambem se aplica aqui.",
            instructions9: "Para a avaliacao de seguranca, quanto maior, melhor. 1 e o pior, e 15 e o melhor.",
            URLplaceholder: "URL de Replay",
            invalidURL: "URL Invalida",
            downloadInstructions: "Clique nesse link com o botao direito e escolha Salvar Como!",
            roundSelect: "Selecione uma Rodada",
            playerSelect: "Trocar de Jogador",
            previousTurn: "Turno anterior",
            nextTurn: "Proximo turno",
            nextIssue: "Proximo problema",
            turn: "{{round}}, Turno {{turn}}",
            discards: "Pecas em seus descartes: {{symbols}} ({{tiles}})",
            calls: "Suas chamadas: {{calls}}",
            callsSeparator: ", ",
            tenhouLinkText: "[Analise de Ukeire do Tenhou]",
            replayError: "Envie-me este replay, algo quebrou.",
            noName: "Deconhecido",
            startingHand: "Sua mao inicial e {{hand}}. Esta a {{count}} peca de distancia de estar pronta. O indicador de dora e {{dora}}.",
            startingHand_plural: "Sua mao inicial e {{hand}}. Esta a {{count}} pecas de distancia de estar pronta. O indicador de dora e {{dora}}.",
            unknownAction: "Hey, este replay tem algo que eu nao levei em consideracao. Por favor envie-me este replay para que eu possa adicionar isso. {{debugInfo}}",
            call: "Voce pediu o {{tile}} para completar {{meld}}. ({{hand}})",
            callSameShanten: "Essa chamado nao lhe deixou mais proximo de uma mao pronta.",
            ryuukyoku: "A rodada terminou em empate.",
            playerRiichi: "Voce declarou riichi. Finalizando analise.",
            otherRiichi: "O jogador {{number}} declarou riichi. ",
            fold: "Voce ainda esta a {{shanten}} pecas de distancia de uma mao pronta, entao voce deveria abandonar a mao.",
            probablyFold: "Voce esta a uma peca de distancia da mao pronta. Voce deveria considerar abandonar a mao.",
            win: "O jogador {{number}} ganhou a rodada.",
            kandora: "O novo indicador de dora e o {{tile}}.",
            draw: "Voce comprou {{tile}}. ({{hand}})",
            chosenSafety: "O nivel de seguranca do {{tile}} e {{rating}}. ({{- explanation}}) ",
            correctSafety: "Essa era a peca mais segura.",
            bestSafety: "Peca mais segura: {{tile}}, com um nivel de seguranca de {{rating}}. ({{- explanation}})",
            safetyExplanations: {
                zero: "Voce nao deveria ver essa mensagem. Me avise se a ver.",
                one: "4/5/6 nao suji",
                two: "3/7 nao suji",
                three: "2/8 nao suji",
                four: "apenas uma chance",
                five: "1/9 nao suji",
                six: "primeira peca de honra",
                seven: "3/7 suji",
                eight: "2/8 suji",
                nine: "4/5/6 suji",
                ten: "segunda peca de honra",
                eleven: "primeiro terminal suji",
                twelve: "segundo terminal suji",
                thirteen: "terceiro terminal suji / terceira honra",
                fourteen: "quarto terminal suji / quarta honra",
                fifteen: "genbutsu, peca 100% segura"
            }
        },
        explorer: {
            warning: "Aviso: carregar uma mao pode travar a pagina por 5-10 segundos, ou mais se voce possuir um computador antigo, dependendo da complexidade da mao. Carregar uma mao mostrara todos os ukeire e possibilidades de melhoria para cada descarte, mesmo os que recuam o shanten. Por padrao, opcoes que sao estritamente piores que outra opcao option nao serao exibidas, mas voce pode pressionar o botao abaixo para mudar isso. Se voce precisa apenas da informacao de ukeire, tenhou.net/2/ sera suficiente.",
            shanten: "Shanten: O numero de pecas de distancia em que sua mao esta de estar pronta.",
            ukeire: "Ukeire: O numero de pecas que reduzem seu shanten.",
            notableDiscards: "Mostrar Apenas Descartes Notaveis",
            allDiscards: "Mostrar Todos os Descartes Possiveis",
            discardInfo: {
                discard: "Descartando o {{tile}}:",
                shanten: "Shanten: {{count}}",
                ukeire: "Ukeire: {{count}} ({{tiles}})",
                expand: "Mostrar o Ukeire do proximo Shanten",
                draw: "Compra {{draw}}, descarte {{discard}}: {{count}} ukeire",
                average: "Media: {{average}}",
                upgrades: "Pecas que aumentam ukeire: {{count}} ({{tiles}})",
                expandUpgrades: "Mostrar Resultados da Melhoria"
            }
        },
        defense: {
            instructions: "Descarte a peca mais segura.",
            finalHands: "Maos Finais:",
            hand: "{{player}}: {{hand}}",
            safetyRatings: "Niveis de Seguranca",
            averagedSafetyRating: "Contra multiplos riichis, os niveis de seguranca serao combinados por media aritmetica, e o maior nivel sera escolhido como melhor peca.",
            safetyRating: "{{rating}}: {{- explanation}}",
            riichiCount: "Numero de riichis: ",
            minTurns: "Minimo de turnos antes de riichi ser declarado: ",
            tilesInHand: "Numero de pecas na mao: "
        },
        utils: {
            convertHeader: "Conversao de Mao",
            convertButtonLabel: "Converter Mao",
            ascii: "ASCII:",
            emoji: "Emoji:",
            stateHeader: "Gerador de Estado de Jogo Aleatorio",
            playerLabel: "{{seat}} Jogador {{you}}",
            points: "Pontos:",
            discards: "Descartes:",
            stateButtonLabel: "Gerar Novo Estado",
            info: "e o turno {{turn}} em {{round}}. Voce e o jogador {{seat}}.",
            dora: "O indicador de dora e o {{tile}}."
        }
    }
}